// DTOs for the new payment-core PaymentIntermediary CRUD endpoints
// (replaces the legacy Airtable-backed /airtable/paymentIntermediaries shape).
// Backend: GET/POST/PUT/PATCH /api/v1/operations/paymentIntermediaries

export type PaymentIntermediaryStatus = 'ACTIVE' | 'INACTIVE';

/** Status path param accepted by GET /paymentIntermediaries/{status}. */
export type PaymentIntermediaryStatusFilter = 'ALL' | 'ACTIVE' | 'INACTIVE';

export const PaymentIntermediaryStatusFilter = {
  ALL: 'ALL',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const satisfies Record<PaymentIntermediaryStatusFilter, PaymentIntermediaryStatusFilter>;

export interface PaymentIntermediary {
  id: number;
  name: string;
  accountNumber: string;
  status: PaymentIntermediaryStatus;
  statusDescription: string;
}

export interface PaymentIntermediaryCreateRequest {
  name: string;
  accountNumber: string;
  status: PaymentIntermediaryStatus;
}

export interface PaymentIntermediaryUpdateRequest {
  name: string;
  accountNumber: string;
}

export interface PaymentIntermediaryStatusUpdateRequest {
  status: PaymentIntermediaryStatus;
}
